import React from "react";
import HackMemPool from "../components/hacks/HackMempool";

import HackLayout from "../components/hacks/HackLayout";

const HackMempoolPage = () => {
  return (
    <HackLayout activeId="3">
      <HackMemPool />
    </HackLayout>
  );
};

export default HackMempoolPage;
